module.exports = __webpack_public_path__ + "img/warning.b660d583.svg";